import { render, staticRenderFns } from "./ViewComponent.html?vue&type=template&id=19e3e1bd&scoped=true&external"
import script from "./ViewComponent.js?vue&type=script&lang=js&external"
export * from "./ViewComponent.js?vue&type=script&lang=js&external"
import style0 from "./ViewComponent.scss?vue&type=style&index=0&id=19e3e1bd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3e1bd",
  null
  
)

export default component.exports